import * as fromPropertyDetails from './property-details.reducer';
import * as fromPropertyUploads from './property-uploads.reducer';
import * as fromSimilarProperties from './similar-properties.reducer';
import * as fromPropertyNotes from './property-notes.reducer';
import {Action, combineReducers, createFeatureSelector, createSelector} from '@ngrx/store';

export const propertyFeatureKey = 'property';

export interface PropertyState {
  [fromPropertyDetails.propertyDetailsKey]: fromPropertyDetails.State;
  [fromPropertyNotes.propertyNotesKey]: fromPropertyNotes.State;
  [fromPropertyUploads.propertyUploadsKey]: fromPropertyUploads.State;
  [fromSimilarProperties.similarPropertiesKey]: fromSimilarProperties.State;
}

export interface State {
  [propertyFeatureKey]: PropertyState;
}

export function reducers(state: PropertyState | undefined, action: Action): PropertyState {
  return combineReducers({
    [fromPropertyDetails.propertyDetailsKey]: fromPropertyDetails.reducer,
    [fromPropertyNotes.propertyNotesKey]: fromPropertyNotes.reducer,
    [fromPropertyUploads.propertyUploadsKey]: fromPropertyUploads.reducer,
    [fromSimilarProperties.similarPropertiesKey]: fromSimilarProperties.reducer,
  })(state, action);
}

export const selectPropertyState = createFeatureSelector<PropertyState>(
  propertyFeatureKey
);

export const selectPropertyDetailsState = createSelector(
  selectPropertyState,
  (state) => state.propertyDetails
);

export const selectPropertyNotesState = createSelector(
  selectPropertyState,
  (state) => state.propertyNotes
);

export const selectPropertyUploadsState = createSelector(
  selectPropertyState,
  (state) => state.propertyUploads
);

export const selectSimilarPropertiesState = createSelector(
  selectPropertyState,
  (state) => state.similarProperties
);
